import { PageLoader } from "@forwardflow/ui";
import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";

const PhoneNumber = lazy(() => import("../../components/PhoneNumber"));
const AllPhoneNumbers = lazy(
  () => import("../../components/PhoneNumber/AllPhoneNumbers")
);
const ViewPhoneNumbers = lazy(
  () => import("../../components/PhoneNumber/ViewPhoneNumber")
);
const ReplacePhoneNumber = lazy(
  () => import("../../components/PhoneNumber/ReplacePhoneNumber")
);

const PhoneNumberRoutes = () => {
  return (
    <>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="" element={<PhoneNumber />}>
            <Route path="all" element={<AllPhoneNumbers />} />
            <Route path="unused" element={<AllPhoneNumbers />} />
            <Route path=":id" element={<ViewPhoneNumbers />} />
            <Route path="replace" element={<ReplacePhoneNumber />} />
          </Route>
        </Routes>
      </Suspense>
    </>
  );
};

export default PhoneNumberRoutes;
